import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getLevelOnePurposeQuery = () => {
    return axios.get(apiurl?.getLevelOnePurpose);
};

const getLevelOnePurpose = () => {
    return useQuery(['getLevelOnePurpose'],
        () => getLevelOnePurposeQuery(), { refetchOnWindowFocus: false });
};

export default getLevelOnePurpose;
